import React, { useState, useEffect } from 'react'
import slaRepository from '../SlaRepository'
import { makeStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import DownloadIcon from '@material-ui/icons/CloudDownload'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import { secondsToStringTimer } from '../../../utils/Formatter'
import { Typography, Tooltip, IconButton } from '@material-ui/core'
import statusSolicitacoesRepository from '../StatusSolicitacoesRepository'
import useQueryFilter from '../useQueryFilter'
import {
  FonteLiberacaoLabelEnum,
  StatusEnum,
  StatusEnumAbrev
} from '../../Solicitacoes/components'
import { downloadCsv } from '../../../utils/DownloadCsv'

const useStyles = makeStyles(theme => ({
  pd: {
    padding: theme.spacing(2),
    paddingBottom: 0
  },
  parent: {
    marginTop: theme.spacing(1),
    overflowY: 'auto',
    transform: 'rotateX(180deg)'
  },
  child: {
    transform: 'rotateX(180deg)'
  },
  noWrap: {
    whiteSpace: 'nowrap'
  }
}))

export default function TableSolicitacaoCentroCusto(props) {
  const classes = useStyles()
  const [tableData, setTableData] = useState([])
  const [statusData, setStatusData] = useState([])
  const [fontesLiberacaoData, setFonteLiberacaoData] = useState([])

  const buildTable = (
    solicitacoesUnidade,
    tempoUnidade,
    fontesLiberacao,
    statusFinal
  ) => {
    const table = []
    Object.keys(solicitacoesUnidade).forEach(centroCustoId => {
      const porCentroCusto = solicitacoesUnidade[centroCustoId]

      const countByFonteLiberacao = []
      fontesLiberacao.forEach(fonteLiberacao => {
        const existFonteLiberacao =
          porCentroCusto.groupedByFonteLiberacao[fonteLiberacao]

        if (existFonteLiberacao?.[0]) {
          countByFonteLiberacao[fonteLiberacao] = parseInt(
            existFonteLiberacao[0].count
          )
        } else {
          countByFonteLiberacao[fonteLiberacao] = 0
        }
      })

      const countByStatus = {}
      statusFinal.forEach(status => {
        const existStatus = porCentroCusto.groupedByStatus[status]
        if (existStatus?.[0]) {
          countByStatus[status] = parseInt(existStatus[0].count)
        } else {
          countByStatus[status] = 0
        }
      })

      let tempoAbertoMedio,
        tempoAnaliseMedio,
        tempoPendenteMedio,
        tempoPendenteGestorMedio,
        tempoTotalMedio

      if (tempoUnidade[centroCustoId]) {
        tempoAbertoMedio =
          tempoUnidade[centroCustoId].tempoabertomedio +
          tempoUnidade[centroCustoId].temporeabertomedio
        tempoAnaliseMedio =
          tempoUnidade[centroCustoId].tempoanalisemedio +
          tempoUnidade[centroCustoId].temporeanalisemedio
        tempoPendenteMedio = tempoUnidade[centroCustoId].tempopendentemedio
        tempoPendenteGestorMedio =
          tempoUnidade[centroCustoId].tempopendentegestormedio
        tempoTotalMedio = tempoUnidade[centroCustoId].tempototalmedio
      }

      const countByFontesLiberacaoValues = Object.values(countByFonteLiberacao)
      const countByStatusValues = Object.values(countByStatus)

      const totalSolicitacoes = [
        ...countByFontesLiberacaoValues,
        ...countByStatusValues
      ].reduce((a, b) => a + b, 0)

      table.push({
        unidadeId: centroCustoId,
        unidade: porCentroCusto.centroCusto,
        ...countByFonteLiberacao,
        ...countByStatus,
        totalSolicitacoes,
        tempoAbertoMedio: secondsToStringTimer(tempoAbertoMedio),
        tempoAnaliseMedio: secondsToStringTimer(tempoAnaliseMedio),
        tempoPendenteMedio: secondsToStringTimer(tempoPendenteMedio),
        tempoPendenteGestorMedio: secondsToStringTimer(
          tempoPendenteGestorMedio
        ),
        tempoTotalMedio: secondsToStringTimer(tempoTotalMedio)
      })
    })
    setTableData(table)
  }

  const [query, periodo] = useQueryFilter(props.location.search)
  useEffect(() => {
    async function fetchData(query) {
      if (query.dataInicio && query.dataFim) {
        const [
          responseTempoPorUnidade,
          responseSolicitacoesPorUnidade,
          responseStatusFinal,
          responseFontesLiberacao
        ] = await Promise.all([
          slaRepository.tempoPorUnidade(
            query.dataInicio,
            query.dataFim,
            query.empresaId
          ),
          slaRepository.solicitacoesPorUnidade(
            query.dataInicio,
            query.dataFim,
            query.empresaId
          ),
          statusSolicitacoesRepository.getStatusFinais(),
          statusSolicitacoesRepository.getFontesLiberacao()
        ])

        if (
          responseTempoPorUnidade.ok &&
          responseSolicitacoesPorUnidade.ok &&
          responseStatusFinal.ok &&
          responseFontesLiberacao.ok
        ) {
          const solicitacoesUnidade = responseSolicitacoesPorUnidade.data
          const tempoUnidade = responseTempoPorUnidade.data.reduce((a, b) => {
            a[b.centrocustoid] = b
            return a
          }, {})

          const fontesLiberacaoArray = responseFontesLiberacao.data

          setFonteLiberacaoData(fontesLiberacaoArray)

          const statusNotAllowed = [
            StatusEnum.LIBERADA,
            StatusEnum.LIBERADAGESTOR,
            StatusEnum.LIBERADAAUTOMATICAMENTE,
            StatusEnum.LIBERADACOMPENDENCIA,
            StatusEnum.NAORECOMENDADA
          ]

          const statusArray = responseStatusFinal.data.filter(
            item => !statusNotAllowed.includes(item)
          )

          setStatusData(statusArray)
          buildTable(
            solicitacoesUnidade,
            tempoUnidade,
            fontesLiberacaoArray,
            statusArray
          )
        }
      }
    }
    fetchData(query)
  }, [query])

  const onDownloadClick = async () => {
    await downloadCsv(
      tableData,
      { fields: [] },
      true,
      true,
      'Solicitações Centro de Custo'
    )
  }

  return (
    <Grid item sm={12}>
      <Paper>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
        >
          <Grid item sm={11}>
            <Typography variant="h6" className={classes.pd}>
              Solicitações finalizadas por centro de custo
            </Typography>
            <Typography variant="caption" className={classes.pd}>
              {periodo}
            </Typography>
          </Grid>
          <Grid item sm={1}>
            <Grid container direction="row" justifyContent="center">
              {tableData.length > 0 && (
                <Tooltip title="Baixar lista" aria-label="Baixar lista">
                  <IconButton size="small" onClick={onDownloadClick}>
                    <DownloadIcon />
                  </IconButton>
                </Tooltip>
              )}
            </Grid>
          </Grid>
        </Grid>
        <div className={classes.parent}>
          <Table className={classes.child}>
            <TableHead>
              <TableRow>
                <TableCell align="center">Unidade</TableCell>
                {[...fontesLiberacaoData, ...statusData].map(item => {
                  const label =
                    FonteLiberacaoLabelEnum[item] || StatusEnumAbrev[item]

                  return (
                    <Tooltip key={label} title={label}>
                      <TableCell align="center">{label}</TableCell>
                    </Tooltip>
                  )
                })}
                <TableCell align="center">Total Solicitações</TableCell>
                <TableCell align="center">
                  <span className={classes.noWrap}>Tempo Médio</span>{' '}
                  <span className={classes.noWrap}>na Fila</span>
                </TableCell>
                <TableCell align="center">
                  <span className={classes.noWrap}>Tempo Médio</span> Análise
                </TableCell>
                <TableCell align="center">
                  <span className={classes.noWrap}>Tempo Médio</span> Pendente
                </TableCell>
                <TableCell align="center">
                  <span className={classes.noWrap}>Tempo Médio</span>{' '}
                  <span className={classes.noWrap}>Pendente Monitoramento</span>
                </TableCell>
                <TableCell align="center">
                  <span className={classes.noWrap}>Tempo Médio</span> Total
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tableData.map(row => (
                <TableRow key={row.unidadeId}>
                  <TableCell className={classes.noWrap} align="center">
                    {row.unidade}
                  </TableCell>
                  {[...fontesLiberacaoData, ...statusData].map(item => (
                    <TableCell key={item} align="center">
                      {row[item]}
                    </TableCell>
                  ))}
                  <TableCell align="center">{row.totalSolicitacoes}</TableCell>
                  <TableCell align="center">{row.tempoAbertoMedio}</TableCell>
                  <TableCell align="center">{row.tempoAnaliseMedio}</TableCell>
                  <TableCell align="center">{row.tempoPendenteMedio}</TableCell>
                  <TableCell align="center">
                    {row.tempoPendenteGestorMedio}
                  </TableCell>
                  <TableCell align="center">{row.tempoTotalMedio}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </Paper>
    </Grid>
  )
}
